import React from 'react'
import PropTypes from 'prop-types'
import { withFormState, withFormApi } from 'informed'
import { ReactComponent as ClearButton } from '../../shared/icons/delete.svg'
import style from './styles/forms.module.scss'
import { compose } from 'recompose'
import get from 'lodash/get'

const withMultiField = WrapedComponent => {
	const MultiFieldWrap = ({ formState, formApi, field, validate, multiField: maxFields, label, ...rest }) => {
		const isNotEmpty = val =>
			rest.emptyTest ? rest.emptyTest(val) : !!val

		const getLastVisibleIndex = (values = []) => {		// get index of the last filled out field value in the array
			let lastVisibleIndex = -1;
			[...Array(maxFields)].forEach((_, i) => {
				const index = maxFields - i - 1
				const isVisible = lastVisibleIndex > index || isNotEmpty(values[index])
				if(isVisible && lastVisibleIndex < index) {
					lastVisibleIndex = index
				}
			})
			return lastVisibleIndex
		}

		const clearField = index => e => {
			const { fieldSubmit, smartSubmit } = rest
			let newValues = [...formState.values[field]]
			newValues.splice(index, 1)
			newValues.push(null)
			let lastVisibleIndex = getLastVisibleIndex(newValues)

			let errors = formState.errors[field] || []
			if(errors.length) {		// set errors according to the removed field
				errors.splice(index, 1)
				const newErrors = errors.slice(0, lastVisibleIndex - 1);
				[...Array(maxFields)].forEach((err, i) => {
					formApi.setError(`${field}[${i}]`, newErrors[i])
				})
			}

			formApi.setValues({
				...formState.values,
				[field]: newValues
			})

			if(fieldSubmit) {
				fieldSubmit()
			}
			if(smartSubmit) {
				smartSubmit.submit()
			}
		}

		let lastVisibleIndex = getLastVisibleIndex(formState.values[field]) + 1
		return [...Array(maxFields)].map((_, i) => {
			const isVisible = i <= lastVisibleIndex
			const isLastIndex = i === lastVisibleIndex
			const val = get(formState.values, `${field}[${i}]`)
			const isFilledOut = !!val 		// field has some input


			const fieldProps = {
				field: `${field}[${i}]`,
				validate: isVisible && isFilledOut ? validate : () => {},
				// ...isVisible && isFilledOut && { validate },
				...i === 0 && { label },
				...rest
			}

			return(
				<div
					key={i}
					className={style['clearButton-container']}
					style={{ ...!isVisible && { display: 'none' } }}
				>
					<WrapedComponent {...fieldProps}/>
					{(!isLastIndex || isFilledOut) &&
						<ClearButton className={style.clearButton} onClick={clearField(i)}/>
					}
				</div>
			)
		})
	}

	MultiFieldWrap.propTypes = {
		field: PropTypes.string.isRequired,
		multiField: PropTypes.number.isRequired
	}

	return compose(
		withFormApi,
		withFormState
	)(MultiFieldWrap)
}

export default withMultiField
